module.exports = __webpack_public_path__ + "static/features-best-practices-suggestions-fadcfbc94e524061615b314ec9020375.jpg";